import React, { useState, useEffect } from 'react'
import Menu from '../../molecules/Menu'
import Footer from '../../molecules/Footer'
import AlertWaiting from '../../molecules/AlertWaiting'
import AlertError from '../../molecules/AlertError'
import TitleRoxo from '../../atoms/TitleRoxo'

import { useHistory, useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'

import * as Styled from './styles'
import { loadAndTrackPixel } from '../../../services/pixel'
import { origemAtual, rastrear, sessaoAtualId } from '../../../services/tracking'
import { useRastreioFormulario } from '../../../hooks/useRastreioFormulario'

const nomeCliente = 'nomeCliente'
const CPFOUCNPJ = 'CPFOUCNPJ'
const open = 'open'
const VOLUMES_MEDIOS_ENTREGAS = [
  '0 - 499 entregas',
  '500 - 999 entregas',
  '1.000 - 2.999 entregas',
  '3.000 - 4.999 entregas',
  '+5.000 entregas'
]

export default function Cadastro() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  useEffect(() => {
    loadAndTrackPixel()
  }, [])

  const [waiting, setWaiting] = useState(false)
  const [erroCadastroEmpresa, setErroCadastroEmpresa] = useState('')

  const [codigoIndicacao, setCodigoIndicacao] = useState('')
  const [referralData, setReferralData] = useState(null)
  const [referralError, setReferralError] = useState('')
  const [isValidatingCode, setIsValidatingCode] = useState(false)

  const history = useHistory()
  const location = useLocation()

  // Tag do link de campanha (moovery.com.br/?origem={tag}), guardada por 30 dias
  // mesmo que o visitante tenha entrado por outra página do site.
  const origemLead = origemAtual()
  const rastreio = useRastreioFormulario('passo1')

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const refCode = params.get('ref')
    if (refCode) {
      const codeUpper = refCode.toUpperCase()
      setCodigoIndicacao(codeUpper)
      validateReferralCode(codeUpper)
    }
  }, [location.search])

  const validateReferralCode = async (code) => {
    if (!code || code.trim() === '') {
      setReferralData(null)
      setReferralError('')
      return
    }

    setIsValidatingCode(true)
    setReferralError('')
    setReferralData(null)

    try {
      const response = await fetch(`https://moovery.app/api/empresa/validar_codigo.php?codigo=${code}`)
      const data = await response.json()

      if (data.success && data.valido) {
        setReferralData({
          codigo: code,
          nome: data.nome,
          indicante_id: data.indicante_id,
          tipo: data.tipo
        })
      } else {
        setReferralError(data.message || 'Código inválido')
      }
    } catch (error) {
      setReferralError('Erro ao validar o código. Tente novamente.')
    } finally {
      setIsValidatingCode(false)
    }
  }

  const onSubmit = (data) => {
    if (codigoIndicacao.trim() !== '') {
      if (isValidatingCode) return
      if (referralError || !referralData || referralData.codigo !== codigoIndicacao) {
        setReferralError('Por favor, insira um código válido ou deixe o campo vazio.')
        return
      }
    }

    sessionStorage.setItem(open, 'true')
    localStorage.setItem(CPFOUCNPJ, data.cnpjOuCpf)
    localStorage.setItem(nomeCliente, data.nome)

    sendEmpresas(
      data.razaoSocial,
      data.nome,
      data.email,
      data.telefone,
      data.cnpjOuCpf,
      data.comoConheceu,
      data.volumeMedioEntregas
    )
  }

  async function sendEmpresas(razaoSocial, nome, email, telefone, cnpjOuCpf, comoConheceu, volumeMedioEntregas) {
    const payload = {
      razao_social: razaoSocial,
      nome: nome,
      responsavel: nome,
      email: email.toLowerCase(),
      telefone: telefone,
      cnpjOuCpf: cnpjOuCpf,
      como_conheceu: comoConheceu,
      volume_medio_entregas: volumeMedioEntregas
    }

    if (origemLead) payload.origem_lead = origemLead
    payload.sessao_id = sessaoAtualId()

    if (referralData) {
      payload.codigo_indicacao_usado = referralData.codigo
      payload.indicante_id = referralData.indicante_id
      payload.tipo_indicante = referralData.tipo
    }

    rastrear('step1_submit')
    setWaiting(true)
    setErroCadastroEmpresa('')
    let aguardandoRedirecionamento = false

    try {
      const response = await fetch('https://moovery.app/api/empresa/crm_passo1.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      const data = await response.json()

      if (response.status === 409) {
        rastrear('step1_error', { dados: { status: 409 } })
        setErroCadastroEmpresa(data?.error?.message || 'Empresa já cadastrada.')
        setTimeout(() => setErroCadastroEmpresa(''), 4000)
        return
      }

      if (!data?.error && data?.data?.code === 201) {
        rastreio.concluir()
        rastrear('step1_success')
        aguardandoRedirecionamento = true
        setTimeout(() => {
          setWaiting(false)
          history.push('./cadastroFinal')
        }, 2000)
        return
      }

      rastrear('step1_error', { dados: { status: response.status } })
      setErroCadastroEmpresa(data?.error?.message || 'Não foi possível iniciar o cadastro. Tente novamente.')
    } catch (error) {
      rastrear('step1_error', { dados: { status: 0 } })
      setErroCadastroEmpresa('Não foi possível iniciar o cadastro. Tente novamente.')
    } finally {
      if (!aguardandoRedirecionamento) setWaiting(false)
    }
  }

  const [phone, setPhone] = useState('')

  const maskPhone = (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})(\d+?)$/, '$1')

  const [cpfOuCnpj, setCpfOucnpj] = useState('')

  const maskCPFouCNPJ = (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/^(\d{2})(\d)/, '$1.$2')
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
    value = value.replace(/(\d{4})(\d)/, '$1-$2')
    return value
  }

  return (
    <>
      {waiting === true && <AlertWaiting />}
      {erroCadastroEmpresa && (
        <AlertError>
          {erroCadastroEmpresa}
        </AlertError>
      )}
      <Menu />
      <Styled.Page>
        <Styled.Shell>
          <Styled.Card>
            <Styled.CardHeader>
              <div>
                <Styled.Badge>Passo 1 de 2</Styled.Badge>
                <TitleRoxo>Cadastre sua empresa</TitleRoxo>
                <Styled.Subtitle>Informações iniciais do responsável e da empresa.</Styled.Subtitle>
              </div>
              <Styled.Stepper>
                <Styled.Step className="active">
                  <Styled.StepIndex className="active">1</Styled.StepIndex>
                  <Styled.StepLabel>
                    <strong>Dados iniciais</strong>
                    <span>Responsável e empresa</span>
                  </Styled.StepLabel>
                </Styled.Step>
                <Styled.Step className="muted">
                  <Styled.StepIndex className="muted">2</Styled.StepIndex>
                  <Styled.StepLabel>
                    <strong>Modalidade e acesso</strong>
                    <span>Modalidade, endereço e senha</span>
                  </Styled.StepLabel>
                </Styled.Step>
              </Styled.Stepper>
            </Styled.CardHeader>

            <form
              onSubmit={handleSubmit(onSubmit, rastreio.registrarErros)}
              {...rastreio.handlers}
              onKeyPress={(event) => {
                event.key === 'Enter' && event.preventDefault()
              }}
            >
              <Styled.FormGrid>
                <Styled.InputField>
                  <label htmlFor="nome">Nome completo</label>
                  <input {...register('nome', { required: true })} placeholder="Nome" />
                  {errors.nome && (
                    <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                  )}
                </Styled.InputField>

                <Styled.InputField>
                  <label htmlFor="email">Email</label>
                  <input
                    {...register('email', {
                      pattern:
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      required: true
                    })}
                    placeholder="email@email.com.br"
                  />
                  {errors.email && (
                    <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                  )}
                </Styled.InputField>

                <Styled.InputField>
                  <label htmlFor="telefone">Whatsapp</label>
                  <input
                    {...register('telefone', {
                      pattern: /^(\(?\d{2}\)?\s)?(\d{4,5}-\d{4})/,
                      required: true
                    })}
                    value={phone}
                    onChange={(event) => setPhone(maskPhone(event.target.value))}
                    placeholder="(00) 00000-0000"
                  />
                  {errors.telefone && (
                    <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                  )}
                </Styled.InputField>

                <Styled.InputField>
                  <label htmlFor="razaoSocial">Razão Social</label>
                  <input
                    id="razaoSocial"
                    placeholder="EXP LOGÍSTICA LTDA"
                    {...register('razaoSocial', { required: true })}
                    autoComplete="organization"
                  />
                  {errors.razaoSocial && (
                    <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                  )}
                </Styled.InputField>

                <Styled.InputField>
                  <label htmlFor="cpfOuCnpj">CNPJ</label>
                  <input
                    {...register('cnpjOuCpf', {
                      required: true,
                      pattern:
                        /^(\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/
                    })}
                    placeholder=""
                    maxLength={18}
                    value={cpfOuCnpj}
                    onChange={(event) => setCpfOucnpj(maskCPFouCNPJ(event.target.value))}
                  />
                  {errors.cnpjOuCpf && (
                    <Styled.SpanError>Preencha o campo ou verifique se está correto</Styled.SpanError>
                  )}
                </Styled.InputField>

                <Styled.InputField>
                  <label htmlFor="codigoIndicacao">Código de Indicação (Opcional)</label>
                  <input
                    id="codigoIndicacao"
                    placeholder="Digite o código de indicação"
                    maxLength={30}
                    value={codigoIndicacao}
                    onChange={(event) => setCodigoIndicacao(event.target.value.toUpperCase())}
                    onBlur={(event) => validateReferralCode(event.target.value)}
                    style={referralData ? { borderColor: '#00C853', backgroundColor: '#f0fdf4' } : {}}
                  />
                  <div style={{ marginTop: '2px' }}>
                    {isValidatingCode && (
                      <span style={{ color: '#510077', fontSize: '12px', fontWeight: '500' }}>
                        Validando código...
                      </span>
                    )}
                    {referralData && !isValidatingCode && (
                      <span style={{ color: '#00C853', fontSize: '12px', fontWeight: 'bold' }}>
                        ✓ Indicado por: {referralData.nome}
                      </span>
                    )}
                    {referralError && !isValidatingCode && (
                      <Styled.SpanError style={{ marginTop: 0 }}>
                        {referralError}
                      </Styled.SpanError>
                    )}
                  </div>
                </Styled.InputField>

                <Styled.InputField style={{ gridColumn: '1 / -1' }}>
                  <label htmlFor="comoConheceu">Como você conheceu a Moovery?</label>
                  <select
                    {...register('comoConheceu', { required: true })}
                    id="comoConheceu"
                    defaultValue=""
                  >
                    <option value="" disabled>Selecione uma opção</option>
                    <option value="me_indicaram">Me indicaram</option>
                    <option value="bag_na_rua">Vi a bag na rua</option>
                    <option value="anuncio">Apareceu um anúncio para mim</option>
                    <option value="instagram">Conheci pelo Instagram</option>
                    <option value="facebook">Conheci pelo Facebook</option>
                    <option value="google">Conheci pelo Google</option>
                    <option value="outros">Outros</option>
                  </select>
                  {errors.comoConheceu && (
                    <Styled.SpanError>Selecione como você conheceu a Moovery</Styled.SpanError>
                  )}
                </Styled.InputField>

                <Styled.InputField style={{ gridColumn: '1 / -1' }}>
                  <label htmlFor="volumeMedioEntregas">Qual é o volume médio de entregas mensais?</label>
                  <select
                    {...register('volumeMedioEntregas', { required: true })}
                    id="volumeMedioEntregas"
                    defaultValue=""
                  >
                    <option value="" disabled>Selecione uma opção</option>
                    {VOLUMES_MEDIOS_ENTREGAS.map((volume) => (
                      <option key={volume} value={volume}>{volume}</option>
                    ))}
                  </select>
                  {errors.volumeMedioEntregas && (
                    <Styled.SpanError>Selecione o volume médio de entregas mensais</Styled.SpanError>
                  )}
                </Styled.InputField>
              </Styled.FormGrid>

              <Styled.Actions>
                <Styled.HelperNote>
                  Próximo: escolha da modalidade, endereço e criação de senha.
                </Styled.HelperNote>
                <Styled.ButtonOrange
                  type="submit"
                  disabled={waiting || isValidatingCode || (codigoIndicacao.trim() !== '' && !!referralError)}
                >
                  Continuar para o próximo passo
                </Styled.ButtonOrange>
              </Styled.Actions>
            </form>
          </Styled.Card>

          <Styled.SideCard>
            <Styled.SideBadge>Fluxo simplificado</Styled.SideBadge>
            <Styled.SideTitle>O que esperar</Styled.SideTitle>
            <Styled.SideList>
              <li>Preencha seus dados básicos e como nos conheceu.</li>
              <li>Na próxima tela, escolha a modalidade e finalize com endereço e senha.</li>
              <li>Usamos o CEP para localizar automaticamente sua empresa.</li>
              <li>Salvamos os dados para você continuar sem perder o passo.</li>
            </Styled.SideList>
          </Styled.SideCard>
        </Styled.Shell>
      </Styled.Page>
      <Footer />
    </>
  )
}
